import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { UserActions } from '../../../../store';
import { Notification } from '../../../Notification';
import '../../Account.css';

export class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstName: props.firstName,
      lastName: props.lastName,
      email: props.email,
      phone: props.phone,
    };
  }

  componentWillUnmount() {
    this.props.clearPasswordError();
    this.props.clearProfileError();
  }

  submitProfile(e) {
    e.preventDefault();
    const { firstName, lastName, email, phone } = this.state;

    this.props.clearPasswordError();
    this.props.clearProfileError();

    if (firstName && lastName && email && phone) {
      this.props.updateProfile({
        first_name: firstName,
        last_name: lastName,
        email,
        phone_number: phone,
      });
    } else {
      this.props.setProfileError('Fields cannot be blank.');
    }
  }

  handleChange(e) {
    const { name, value } = e.target;

    this.setState((state) => ({
      ...state,
      [name]: value,
    }));
  }

  render() {
    const { firstName = '', lastName = '', email = '', phone = '' } = this.state;
    const { profileError, profileMessage } = this.props;

    let messageClasses = 'account__message';
    messageClasses += profileError ? ' account__message--error' : '';
    messageClasses += profileMessage ? ' account__message--success' : '';

    return (
      <form onSubmit={(e) => this.submitProfile(e)} className="account-form">
        <div className="account__body-header">
          <span className="account__body-title">Edit Profile</span>
        </div>
        <div className="account__input-wrapper">
          <label htmlFor="firstName" className="account-field">
            <span className="account__input-text">First Name:</span>
            <input
              className="account__input"
              value={firstName}
              onChange={(e) => this.handleChange(e)}
              type="firstName"
              id="firstName"
              name="firstName"
              placeholder="First Name"
            />
          </label>
        </div>
        <div className="account__input-wrapper">
          <label htmlFor="lastName" className="account-field">
            <span className="account__input-text">Last Name:</span>
            <input
              className="account__input"
              value={lastName}
              onChange={(e) => this.handleChange(e)}
              type="lastName"
              id="lastName"
              name="lastName"
              placeholder="Last Name"
            />
          </label>
        </div>
        <div className="account__input-wrapper">
          <label htmlFor="email" className="account-field">
            <span className="account__input-text">Email:</span>
            <input
              className="account__input"
              value={email}
              onChange={(e) => this.handleChange(e)}
              type="email"
              id="email"
              name="email"
              placeholder="Email"
            />
          </label>
        </div>
        <div className="account__input-wrapper">
          <label htmlFor="phone" className="account-field">
            <span className="account__input-text">Phone Number:</span>
            <input
              className="account__input"
              value={phone}
              onChange={(e) => this.handleChange(e)}
              type="phone"
              id="phone"
              name="phone"
              placeholder="Phone Number"
            />
          </label>
        </div>
        <div className={`account-field account-field--center ${messageClasses}`}>
          {profileError && <Notification message={profileError} type="error" />}
          {profileMessage && <Notification message={profileMessage} type="success" />}
        </div>
        <div className="account-field account-field--center">
          <button type="submit" className="account__button">
            Save
          </button>
        </div>
      </form>
    );
  }
}

Profile.propTypes = {
  profileMessage: PropTypes.string,
  profileError: PropTypes.string,
  email: PropTypes.string.isRequired,
  phone: PropTypes.string.isRequired,
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  updateProfile: PropTypes.func.isRequired,
  setProfileError: PropTypes.func.isRequired,
  clearPasswordError: PropTypes.func.isRequired,
  clearProfileError: PropTypes.func.isRequired,
};

Profile.defaultProps = {
  profileMessage: undefined,
  profileError: undefined,
};

export function mapStateToProps(state) {
  return {
    profileMessage: state.profileReducer.message,
    profileError: state.profileReducer.error,
    email: state.profileReducer.email,
    phone: state.profileReducer.phone,
    firstName: state.profileReducer.firstName,
    lastName: state.profileReducer.lastName,
  };
}

const mapDispatchToProps = {
  updateProfile: UserActions.updateProfile,
  setProfileError: UserActions.setProfileError,
  clearPasswordError: UserActions.clearPasswordError,
  clearProfileError: UserActions.clearProfileError,
};

const ConnectedProfile = connect(mapStateToProps, mapDispatchToProps)(Profile);
export { ConnectedProfile };
